import * as React from 'react';
import styled from 'styled-components';
import { Link } from '@latitude/link';
import { BREAKPOINT } from '@latitude/core/utils/constants';

var FooterLinks = function FooterLinks(props) {
  return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(List, null, props.data.map(function (item, i) {
    return /*#__PURE__*/React.createElement(ListItem, {
      itemProp: "name",
      key: "secondary-menu-" + i
    }, /*#__PURE__*/React.createElement(Link, {
      href: item.link
    }, item.label));
  })));
};

var Outer = /*#__PURE__*/styled.div.withConfig({
  displayName: "FooterLinks__Outer",
  componentId: "sc-g6pj0d-0"
})(["font-size:1rem;line-height:24px;@media (min-width:", "){line-height:32px;}"], BREAKPOINT.LG);
var List = /*#__PURE__*/styled.ul.withConfig({
  displayName: "FooterLinks__List",
  componentId: "sc-g6pj0d-1"
})(["list-style-type:none;padding:0;margin:0;@media (min-width:", "){max-width:100%;display:flex;justify-content:center;flex-wrap:wrap;}"], BREAKPOINT.LG);
var ListItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "FooterLinks__ListItem",
  componentId: "sc-g6pj0d-2"
})(["margin-bottom:8px;&:last-child{margin-bottom:0;}@media (min-width:", "){margin:0 10px;}"], BREAKPOINT.LG);
export default FooterLinks;